import { render } from "./ProjectConfirmationModal.vue?vue&type=template&id=24141c7e&scoped=true"
import script from "./ProjectConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ProjectConfirmationModal.vue?vue&type=script&lang=js"

import "./ProjectConfirmationModal.vue?vue&type=style&index=0&id=24141c7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24141c7e"]])

export default __exports__